/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect } from 'react'
import { useState } from 'react'
import { Fragment } from 'react'
import Header from '../../Components/Header/Header'
import Navbar from '../../Components/Navbar/Navbar'

import PrimaryButton from "../../Components/Buttons/PrimaryButton";


const Form = () => {

    const backendURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));

    const [startDate, setStartDate] = useState('');
    const [finalDate, setFinalDate] = useState('');

    const [leads, setLeads] = useState([]);

    const getData = async () => {
        const res = await axios({
            method: "GET",
            url: `${backendURL}/api/form`,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })

        setLeads(res.data.data.reverse());
    }

    const deleteHandler = async (id) => {

        try {
            const res = await axios({
                method: "DELETE",
                url: `${backendURL}/api/form/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })

            if (res && res.status === 200) {
                const newLeads = leads.filter((lead) => lead._id !== id);
                setLeads(newLeads);
            }
        } catch (error) {
        }

    }

    const handleExport = (e) => {

        let url = `${process.env.REACT_APP_SERVER_URL}/api/export?from=${startDate}&to=${finalDate}`;

        fetch(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
            }
        })
            .then((response) => response.blob())
            .then((blob) => {
                var _url = window.URL.createObjectURL(blob);
                window.open(_url, "_blank").focus();
            }).catch((err) => {
            });

        setStartDate('')
        setFinalDate('')

    }

    useEffect(() => {
        getData();
    }, [])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container' >
                <div className='row'>
                    <div class="col-lg-12 mt-20">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                            <h3>Inquiry Leads</h3>

                            <div style={{ display: 'flex', gap: "10px" }} >
                                <input type='date' value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                <input type='date' value={finalDate} onChange={(e) => setFinalDate(e.target.value)} />

                                <PrimaryButton sx={{ mb: 2, mr: 2 }} variant='contained' onClick={handleExport}>
                                    Export
                                </PrimaryButton>
                            </div>
                        </div>
                        <hr />

                    </div>

                    <div className='col-lg-12'>
                        <table style={{ display: 'block', maxWidth: '100%', overflowX: 'scroll', maxHeight: '600px' }}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Source</th>
                                    <th>Created At</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    leads && leads.length !== 0 && leads.map((lead) => {
                                        return (
                                            <tr key={lead._id} >
                                                <td>{lead.name}</td>
                                                <td>{lead.email}</td>
                                                <td>{lead.phone}</td>
                                                <td>{lead.source}</td>
                                                <td>{new Date(lead.createdAt).toLocaleDateString('en-GB')}</td>
                                                <td class="p-relative">
                                                    <button onClick={() => deleteHandler(lead._id)} class="delete-btn"><i className='fa fa-times'></i></button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Form